import andres from '@/assets/team/Andres.webp';
import bea from '@/assets/team/Bea.webp';
import christopher from '@/assets/team/Christopher.webp';
import diego from '@/assets/team/Diego.webp';
import eugenio from '@/assets/team/Eugenio.webp';
import fernando from '@/assets/team/Fernando.webp';
import marco from '@/assets/team/Marco.webp';
import martin from '@/assets/team/Martin.webp';
import pablo from '@/assets/team/Pablo.webp';
import rocio from '@/assets/team/Rocio.webp';
import seba from '@/assets/team/Seba.webp';
import { StaticImageData } from 'next/image';

export interface TeamMember {
  id: number;
  name: string;
  position: string;
  image: string | StaticImageData;
  department: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: 'Martín Bobillier',
    position: 'CEO',
    image: martin,
    department: 'Co-Founder',
  },
  {
    id: 2,
    name: 'Sebastián Pulgar',
    position: 'CTO',
    image: seba,
    department: 'Co-Founder',
  },
  {
    id: 3,
    name: 'Diego Arredondo',
    position: 'Machine Learning Engineer',
    image: diego,
    department: 'Co-Founder',
  },
  {
    id: 4,
    name: 'Marco Cortés',
    position: 'COO',
    image: marco,
    department: 'Operaciones',
  },
  {
    id: 5,
    name: 'Rocío Alvarado',
    position: 'KAM',
    image: rocio,
    department: 'Operaciones',
  },
  {
    id: 6,
    name: 'Andrés Zavala  ',
    position: 'KAM',
    image: andres,
    department: 'Operaciones',
  },
  {
    id: 7,
    name: 'Beatriz Errázuriz',
    position: 'Desarrolladora Full Stack',
    image: bea,
    department: 'Plataforma',
  },
  {
    id: 8,
    name: 'Eugenio Herrera',
    position: 'Senior Tech Advisor',
    image: eugenio,
    department: 'Tecnología',
  },
  {
    id: 9,
    name: 'Pablo Dawson',
    position: 'Researcher',
    image: pablo,
    department: 'Tecnología',
  },
  {
    id: 10,
    name: 'Fernando Fêtis',
    position: 'Researcher',
    image: fernando,
    department: 'Tecnología',
  },
  {
    id: 11,
    name: 'Christopher Orozco',
    position: 'Edición Post Producción',
    image: christopher,
    department: 'Producción',
  },
];
